import { useLocation } from 'react-router-dom'

export function useDirectoryMode() {
  const { pathname } = useLocation()
  const isEmergency = pathname.startsWith('/emergency-plumbers')
  const isGasSafe = pathname.startsWith('/gas-safe-plumbers')
  const isWaterSafe = pathname.startsWith('/water-safe-plumbers')
  const basePath = isEmergency
    ? '/emergency-plumbers'
    : isGasSafe
      ? '/gas-safe-plumbers'
      : isWaterSafe
        ? '/water-safe-plumbers'
        : '/plumbers'
  /** "Emergency Plumbers" | "Gas Safe Plumbers" | "WaterSafe Plumbers" | "Plumbers" */
  const label = isEmergency
    ? 'Emergency Plumbers'
    : isGasSafe
      ? 'Gas Safe Plumbers'
      : isWaterSafe
        ? 'WaterSafe Plumbers'
        : 'Plumbers'
  /** "Emergency Plumber" | "Gas Safe Plumber" | "WaterSafe Plumber" | "Plumber" */
  const labelSingular = isEmergency
    ? 'Emergency Plumber'
    : isGasSafe
      ? 'Gas Safe Plumber'
      : isWaterSafe
        ? 'WaterSafe Plumber'
        : 'Plumber'
  return { isEmergency, isGasSafe, isWaterSafe, basePath, label, labelSingular }
}
